module.exports = __webpack_public_path__ + "img/wallet_mb_05.16e5acf9.png";